import {
  getLastNdaysLabel as getLabel,
  getLastNdates as getDates,
} from "./getLastNdays";
import { dateExactMatcher } from "./dateExactMatcher";
import {
  branchBasedFeedbackDataFilter,
  getActiveBranchIds,
} from "./multipleBranch/getActiveBranchId";

/*
example of how data is received in the function
const data1 = [
  {
    data: {
      simpleQuestions: [
        {
          question: "whos is who",
          answer: "dsa",
          _id: "666875e1c8554dc7b1815e29",
        },
        {
          question: "its a new question",
          answer: "DSA",
          _id: "666875e1c8554dc7b1815e2a",
        },
        {
          question: "remark",
          answer: "thanks",
          _id: "666875e1c8554dc7b1815e2b",
        },
      ],
      optionQuestions: [
        {
          question: "this is first option question",
          answer: "option 2",
          _id: "666875e1c8554dc7b1815e2c",
        },
        {
          question: "this is second option question",
          answer: "option 1",
          _id: "666875e1c8554dc7b1815e2d",
        },
        {
          question: "this is third option question",
          answer: "option 3",
          _id: "666875e1c8554dc7b1815e2e",
        },
      ],
      checkQuestions: [],
    },
    _id: "666875e1c8554dc7b1815e28",
    admin_id: "6666b64698d6ffd02df1974b",
    rating: 5,
    createdAt: "2024-06-13T16:05:53.760Z",
    updatedAt: "2024-06-11T16:05:53.760Z",
    __v: 0,
  },
  {
    data: {
      simpleQuestions: [
        {
          question: "whos is who",
          answer: "dsa",
          _id: "666875e1c8554dc7b1815e29",
        },
        {
          question: "its a new question",
          answer: "DSA",
          _id: "666875e1c8554dc7b1815e2a",
        },
        {
          question: "remark",
          answer: "thanks",
          _id: "666875e1c8554dc7b1815e2b",
        },
      ],
      optionQuestions: [
        {
          question: "this is first option question",
          answer: "option 2",
          _id: "666875e1c8554dc7b1815e2c",
        },
        {
          question: "this is second option question",
          answer: "option 1",
          _id: "666875e1c8554dc7b1815e2d",
        },
        {
          question: "this is third option question",
          answer: "option 3",
          _id: "666875e1c8554dc7b1815e2e",
        },
      ],
      checkQuestions: [],
    },
    _id: "666875e1c8554dc7b1815e28",
    admin_id: "6666b64698d6ffd02df1974b",
    rating: 1,
    createdAt: "2024-06-11T16:05:53.760Z",
    updatedAt: "2024-06-11T16:05:53.760Z",
    __v: 0,
  },
  {
    data: {
      simpleQuestions: [
        {
          question: "whos is who",
          answer: "dsa",
          _id: "666875e1c8554dc7b1815e29",
        },
        {
          question: "its a new question",
          answer: "DSA",
          _id: "666875e1c8554dc7b1815e2a",
        },
        {
          question: "remark",
          answer: "thanks",
          _id: "666875e1c8554dc7b1815e2b",
        },
      ],
      optionQuestions: [
        {
          question: "this is first option question",
          answer: "option 2",
          _id: "666875e1c8554dc7b1815e2c",
        },
        {
          question: "this is second option question",
          answer: "option 1",
          _id: "666875e1c8554dc7b1815e2d",
        },
        {
          question: "this is third option question",
          answer: "option 3",
          _id: "666875e1c8554dc7b1815e2e",
        },
      ],
      checkQuestions: [],
    },
    _id: "666875e1c8554dc7b1815e28",
    admin_id: "6666b64698d6ffd02df1974b",
    rating: 5,
    createdAt: "2024-06-11T16:05:53.760Z",
    updatedAt: "2024-06-11T16:05:53.760Z",
    __v: 0,
  },
];

// below is formate how we should send the data
export const data3 = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],

  datasets: [
    {
      label: "1 Star",
      data: [10, 15, 10, 15, 15, 5, 15],
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "5 Stars",
      data: [10, 15, 5, 10, 15, 25, 15],
      backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
  ],
};

*/
export function ratingBarGraph(days, data1) {
  // input data here is raw feedback data..
  const b = JSON.parse(localStorage.getItem("branches"));
  const branch = getActiveBranchIds(b);
  // console.log(data1);
  if (branch.length > 1) return null;
  const data = branchBasedFeedbackDataFilter(data1, branch[0]);
  // console.log(data);
  if (data?.length == 0 || data == null) {
    return;
  }

  //Phase 1 Extracting relevant info from Feedback Data.
  // first we prepare data in date and star frequency form,
  let rawData = {
    dates: [],
    oneStar: [],
    fiveStar: [],
  };

  // Now we start filling the rawData object.
  rawData.dates = getLabel(days);

  rawData.dates.forEach((d, index) => {
    let oneStr = 0;
    let fiveStr = 0;

    data.forEach((item) => {
      if (dateExactMatcher(d, item.createdAt)) {
        if (item.rating == 5) fiveStr++;
        if (item.rating == 1) oneStr++;
      }
      rawData.oneStar[index] = oneStr;
      rawData.fiveStar[index] = fiveStr;
    });
  });

  // Phase 2now we fill the raw data object inside the resultData in format which is accepted by bar chart
  let resultData = {
    labels: [],
    datasets: [
      {
        label: "1 Star",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "5 Star",
        data: [],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  // we reverse() so that dates start from Left to right ie latest being on Right side.
  resultData.labels = [...rawData.dates].reverse();
  resultData.datasets[0].data = [...rawData.oneStar].reverse();
  resultData.datasets[1].data = [...rawData.fiveStar].reverse();

  return resultData;
}
